export default [
  'BOTCreditCard',
  'BOTCreditCardTeaser'
]

/*
Appears on:
/credit
*/
